<template lang="pug">
  datepicker(:value="item.task_due_date" @input="update" hideDetails)
    template(v-slot:activator="datepicker")
      span(@click="datepicker.show")
        template(v-if="item.task_due_date") {{ item.task_due_date | formattedDate }}
        template(v-else)
          ico-calendar(color="#758289").pointer
    template(v-slot:default="props")
      div
        v-date-picker(
          no-title
          :value="datepickerValue"
          @input="update($event)"
          @change="props.process"
        )
        .datepicker-bottom(@click="props.process")
          v-btn(block color="primary" @click="update(null)") Remove
</template>

<script>
import Dayjs from 'dayjs'
import errorsMixin from '@/mixins/errors.mixin'
import { convertToDefaultBackendFormat } from '@/util'

export default {
  name: 'ReapplyDueDate',

  mixins: [errorsMixin],

  inject: ['reapplyService'],

  props: {
    item: Object,
    customUpdate: Boolean
  },

  computed: {
    datepickerValue() {
      if (!this.item.task_due_date) return null
      return convertToDefaultBackendFormat(this.item.task_due_date)
    }
  },

  methods: {
    async update(date) {
      try {
        let _date = this.getFormattedDate(date)
        if (this.customUpdate) return this.$emit('change', _date)
        if (this.loading) return
        this.loading = true

        await this.reapplyService.updateDueDate(this.item.id, _date)
        this.item.task_due_date = date
        this.$notify({type: 'success', text: 'Successful updated'})
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_CRM})
      } finally {
        this.loading = false
      }
    },

    getFormattedDate(date) {
      if (!date) return null
      return Dayjs(new Date(date)).toISOString()
    }
  },

  components: {
    icoCalendar: () => import('@/assets/img/ui/crm/IcoCalendar.vue'),
    Datepicker: () => import('@/app/admin/components/CrmDatepicker.vue'),
  }
}
</script>
